import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Box, Typography } from '@mui/material';
import EirOrderedOfferType from './EirOrderdOfferType';
import styles from './style';
import { getLocalStorage, setLocalStorageWithPrefix } from '../../hooks/useLocalStorage';
import { getCookie } from '../../hooks/useCookie';

const EirSummary = ({
  cartData,
  tacticalOffers,
  loading,
  deleteIcon,
  openConfirmationModal,
  getClickedItem,
  isCurrentServiceComplete,

  // isPortingComplete,
  summaryData,
  setHasMissingStep,
  systemAddedOffer,
  setIncompleteCart,
  cmsData,
  pSIMCode,
  refreshSummary,
}) => {
  const theme = useTheme();
  useEffect(() => {
    let orderDetails = {};
    if (cartData) {
      const hasBB = cartData?.cart?.filter(off => off.itemType === 'DUALPLAY');
      orderDetails = {
        reference:
          getCookie('reference') || getLocalStorage('PROSPECTUUID') || getLocalStorage('REF'),
        cartType: getCookie('cart_Type') ? getCookie('cart_Type') : 'NEW_ACQUISITION',
        products: cartData?.cart?.map(off => off?.itemType),
        appointmentType: hasBB?.map(apt => apt?.appointmentType)[0],
        channel: getCookie('channel') ? getCookie('channel') : 'ESHOP',
      };
      if (!hasBB) delete orderDetails.appointmentType;
      setLocalStorageWithPrefix('ION_ORDER_DETAILS', JSON.stringify(orderDetails));
    }
  }, [cartData]);

  return (
    <Paper sx={styles(theme).summaryCard}>
      <Box sx={styles(theme).summaryContainer}>
        <Typography variant='h2' sx={styles(theme).cartTitle}>
          {summaryData?.summary?.title?.cartTitle}
        </Typography>

        <EirOrderedOfferType
          summaryData={summaryData}
          cartData={cartData}
          tacticalOffers={tacticalOffers}
          loading={loading}
          deleteIcon={deleteIcon}
          openConfirmationModal={openConfirmationModal}
          getClickedItem={getClickedItem}
          isCurrentServiceComplete={isCurrentServiceComplete}
          // isPortingComplete={isPortingComplete}
          setHasMissingStep={setHasMissingStep}
          systemAddedOffer={systemAddedOffer}
          setIncompleteCart={setIncompleteCart}
          cmsData={cmsData}
          pSIMCode={pSIMCode}
          refreshSummary={refreshSummary}
        />
      </Box>
    </Paper>
  );
};
export default EirSummary;
